import type { IconSvgObject } from './types';

const StretchVerticalIcon: IconSvgObject = [
  ["path", { d: "M7.99219 2C9.09676 2 9.99219 2.89543 9.99219 4L9.99219 20C9.99219 21.1046 9.09676 22 7.99219 22H5.99219C4.88762 22 3.99219 21.1046 3.99219 20L3.99219 4C3.99219 2.89543 4.88762 2 5.99219 2L7.99219 2Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.9922 2C19.0968 2 19.9922 2.89543 19.9922 4L19.9922 20C19.9922 21.1046 19.0968 22 17.9922 22H15.9922C14.8876 22 13.9922 21.1046 13.9922 20L13.9922 4C13.9922 2.89543 14.8876 2 15.9922 2L17.9922 2Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default StretchVerticalIcon;
